// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Kontent$PrezzeeRibbon from "../../personal/Kontent/Kontent.bs.js";
import * as Footer__Responsive$PrezzeeRibbon from "./Footer__Responsive.bs.js";

var copyright = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.gridColumn(1, -1),
      BsCssJs$PrezzeeRibbon.textAlign("center"),
      BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(12)),
      BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.px(20)),
      BsCssJs$PrezzeeRibbon.media(Footer__Responsive$PrezzeeRibbon.desktop, [BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(50))]),
      BsCssJs$PrezzeeRibbon.media(Footer__Responsive$PrezzeeRibbon.tabletOrMobile, [BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(30))])
    ]);

var Styles = {
  copyright: copyright
};

function Footer__Copyright(props) {
  return JsxRuntime.jsx(Kontent$PrezzeeRibbon.Consumer.make, {
              children: JsxRuntime.jsx("div", {
                    children: props.children,
                    className: copyright
                  })
            });
}

var make = Footer__Copyright;

export {
  Styles ,
  make ,
}
/* copyright Not a pure module */
